import styled from "@emotion/styled";

export const TruckCubeCountTrackerContainer = styled.div(({ theme }) => ({
	...theme.project.typography.body.body2,
	display: "flex",
	gap: "2px",
	flexDirection: "column",
	color: theme.project.colors.fontColors.main,
	flex: 1
}));
